// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8812) return "static/chunks/8812-472b011208232cca.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6589 ? "6264a4a4" : chunkId) + "." + {"4759":"b137cb627fb1e0ec","6589":"2367d8851cf5ebb7","9978":"dd158920e403173a"}[chunkId] + ".js";
};